import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'ValidateTicket',
            args: {
                ...payload,
            },
        });

        if (result.entry) {
            return {
                entry: result.entry,
                success: true,
                message: "Your entry has been accepted and added to the list on the 'My Entries' page.",
            };
        } else if (result.response) {
            return {
                success: false,
                message: result.response.message,
            };
        } else {
            return {
                success: false,
                message: 'An Unspecified Error Occurred.',
            };
        }
    };
};
